import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';

export default function Footer({ lang, onOpenCookies }) {
  const { t } = useTranslation();
  const base = `/${lang}`;
  const year = new Date().getFullYear();

  return (
    <footer className="aq-footer" id="footer">
      <div className="aq-container aq-footer__grid">
        <div className="aq-footer__brand">
          <Logo variant="light" size={30} />
          <p className="aq-footer__about">{t('footer.about_text')}</p>
          <p className="aq-footer__risk">{t('footer.risk_notice')}</p>
        </div>

        <div>
          <h4 className="aq-footer__title">{t('footer.nav_title')}</h4>
          <ul className="aq-footer__list">
            <li><a href={`${base}#how`}>{t('nav.how')}</a></li>
            <li><a href={`${base}#projects`}>{t('nav.projects')}</a></li>
            <li><a href={`${base}#transparency`}>{t('nav.transparency')}</a></li>
            <li><a href={`${base}#faq`}>{t('nav.faq')}</a></li>
            <li><a href={`${base}#contact`}>{t('nav.contact')}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="aq-footer__title">{t('footer.legal_title')}</h4>
          <ul className="aq-footer__list">
            <li><Link to={`${base}/privacy`}>{t('footer.privacy')}</Link></li>
            <li><Link to={`${base}/cookies`}>{t('footer.cookies')}</Link></li>
            <li><Link to={`${base}/terms`}>{t('footer.terms')}</Link></li>
            <li>
              <button
                type="button"
                className="aq-footer__linkbtn"
                onClick={onOpenCookies}
                data-testid="footer-cookie-preferences"
              >
                {t('cookies.open_preferences')}
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="aq-footer__title">{t('footer.company_title')}</h4>
          <ul className="aq-footer__list aq-footer__list--muted">
            <li>{t('footer.address')}</li>
            <li>{t('footer.registration')}</li>
            <li>{t('footer.tax_id')}</li>
            <li>{t('footer.license')}</li>
            <li>{t('footer.jurisdiction')}</li>
            <li>{t('footer.incorporation')}</li>
            <li>{t('footer.share_capital')}</li>
            <li>
              {t('footer.email_label')}: <a href={`mailto:${t('footer.email')}`}>{t('footer.email')}</a>
            </li>
            <li>
              {t('footer.phone_label')}: <a href={`tel:${t('footer.phone').replace(/\s/g, '')}`}>{t('footer.phone')}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="aq-container aq-footer__bottom">
        <span>© {year} Aurelqen d.o.o. {t('footer.rights')}</span>
        <span className="aq-footer__bottom-links">
          <Link to={`${base}/privacy`}>{t('footer.privacy')}</Link>
          <Link to={`${base}/cookies`}>{t('footer.cookies')}</Link>
          <Link to={`${base}/terms`}>{t('footer.terms')}</Link>
        </span>
      </div>
    </footer>
  );
}
